import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { process, State } from '@progress/kendo-data-query';
import { DailyLegLoadFrequencyEditor } from '../../../../../models/daily-leg-loads/daily-leg-load.models';
import { DailyLegLoadFrequencyService } from '../../../../../services/daily-leg-loads/daily-leg-load-frequency.service';
import { GridComponent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { frequencyColumns } from './daily-leg-loads-frequency.config';
import { PtLuxonDate } from '../../../../../models/projects/date.models';

@Component({
  selector: 'daily-leg-loads-frequency-change-grid',
  templateUrl: 'daily-leg-loads-frequency-change-grid.html'
})
export class DailyLegLoadsFrequencyChangeGridComponent {
  @Input() dailyLogDate: PtLuxonDate;
  @Input() currentEditor: DailyLegLoadFrequencyEditor;
  @Input() loading: boolean;
  @Output() public addFrequencyChangeClicked: EventEmitter<void> = new EventEmitter();
  @Output() public deleteFrequencyChangeClicked: EventEmitter<DailyLegLoadFrequencyEditor> = new EventEmitter();
  @ViewChild('frequencyGrid') frequencyGrid?: GridComponent;

  gridData: GridDataResult;
  columns = frequencyColumns;
  frequencyData: DailyLegLoadFrequencyEditor[];

  state: State = {
    take: 5,
    skip: 0,
    filter: {
      logic: 'and',
      filters: []
    },
    sort: [
      {
        field: 'effectiveFromDate',
        dir: 'desc'
      },
    ],
  };

  constructor(private dailyLegLoadFrequencyService: DailyLegLoadFrequencyService) {

  }

  ngOnInit() {
    this.loadFrequencyGrid();
  }

  public pageChange(event: PageChangeEvent): void {
    this.state.skip = event.skip;
    this.loadItems();
  }

  emitDeleteFrequencyChange(row: DailyLegLoadFrequencyEditor) {
    this.deleteFrequencyChangeClicked.emit(row);
  }

  emitAddFrequencyChange() {
    this.addFrequencyChangeClicked.emit();
  }

  private async loadFrequencyGrid() {
    this.dailyLegLoadFrequencyService.getGridData(this.dailyLogDate.dateTime).then(data => {
      this.goToLatestFrequencyChangePage(data);
      this.frequencyData = data;
      this.loadItems();
    });
  }

  private loadItems(): void {
    this.gridData = process(this.frequencyData, this.state);
  }

  private goToLatestFrequencyChangePage(data: DailyLegLoadFrequencyEditor[]) {
    const index = data.findIndex(e => e.id === this.currentEditor.id);

    if (index !== -1) {
      this.state.skip = (Math.floor(index / this.state.take)) * this.state.take;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/daily-leg-loads/daily-leg-load-manage-readings/components/daily-leg-load-frequency-change-grid/daily-leg-loads-frequency-change-grid.ts